<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <canvas
      id="myChart16"
      width="70"
      height="40"
    />
    <div
      id="legendaSupervisorEmpresa"
      class="text-center px-3"
    >
      <div v-if="text">
        <h3>{{ text }}</h3>
      </div>
      <div v-else>
        <v-row>
          <div
            v-for="legenda in legendaEmpresa"
            :key="legenda.text"
          >
            <v-avatar
              class="mr-1"
              :color="legenda.cor"
              size="12"
            />
            <span class="mr-3 font-weight-light">{{ legenda.text }}</span>
          </div>
        </v-row><br><br>
      </div>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import Time from '../../../../services/time'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashoboardTicketSupervisorEmpresa',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      supervisor: [],
      receita: [],
      segmento: [],
      rede: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      vendedor: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      legendaEmpresa: [],
      text: null,
      montarGrafico: true,
      loading: false,
      error: null,
      exibirLegenda: false,
    }),

    created () {
      eventEmit.$on('update-ticket', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-ticket', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, supervisor, receita, segmento, rede, categoria, promotor, classificacao, vendedor) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.vendedor = vendedor

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Time.showTicketSupervisorxEmpresa(this.primeiroDia, this.dataFinal, this.select, this.supervisor, this.receita, localStorage.tokencontrato, this.segmento, this.rede, this.categoria, this.promotor, this.classificacao, this.vendedor).then(resposta => {
          if (resposta.data.status) {
            const setPerson = new Set()

            this.legendaEmpresa = resposta.data.legenda.filter((person) => {
              const duplicatedPerson = setPerson.has(person.text)
              setPerson.add(person.text)
              return !duplicatedPerson
            })

            const ctx = document.getElementById('myChart16').getContext('2d')

            var mobile = !(window.innerWidth < 600)

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: resposta.data.supervisor,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: resposta.data.colors,
                    order: 2,
                  },
                  {
                    label: 'Meta',
                    data: resposta.data.mediaSupervisor,
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    type: 'line',
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: false,
                    align: 'end',
                    color: function (context) {
                      if (context.dataset.label === 'Faturamento') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 0) {
                        return 'Faturamento: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else if (tooltipItem.datasetIndex === 1) {
                        return ' Média: ' + resposta.data.valorMedia.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há faturamento para o período selecionado.') {
            this.text = resposta.data.msg

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data inicial não pode ser maior que a data Final') {
            this.text = resposta.data.msg

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.msg)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style lang="sass">
  #legendaSupervisorEmpresa
    margin: 1rem 0 0 5rem

</style>

<style scoped>
 .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    #myChart16 {
      margin: -1rem 0 3rem 1rem;
      width: 330px !important;
      height: 260px !important;
    }

    #legendaSupervisorEmpresa {
      font-size: 10px;
      margin: 1rem 0 1rem 2rem
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart16 {
      margin: -1rem 0 0 0;
      width: 800px !important;
      height: 500px !important;
    }

    #legendaSupervisorEmpresa {
      font-size: 14px;
      margin: 1rem 0 2rem 10rem
    }
  }
</style>
